export class SIQInputCardTheme {
  titleColor = "null";
  textFieldTextColor = "null";
  textFieldBackgroundColor = "null";
  textFieldPlaceholderColor = "null";
  sendButtonBackgroundColor = "null";
  sendButtonIconColor = "null";
  separatorColor = "null";
}
//# sourceMappingURL=SIQInputCardTheme.js.map